const projects = [
    {
      title: "Finsta – Loan Management System",
      description:
        "Designed and developed a secure, cloud-native loan management system processing over 50,000+ financial transactions per day. Integrated Amazon S3 for secure document storage and AWS Lambda for automation of loan disbursements.",
      tech:
        "Node.js, Angular, PostgreSQL, AWS Lambda, S3, API Gateway, RBAC, Audit Logs",
      achievements:
        "Implemented role-based access control (RBAC), JWT authentication, and audit trails to meet banking compliance and security standards. Reduced loan application processing time by 45% through efficient workflow automation and database indexing."
    },
    {
      title: "KapilGuru – E-Learning Platform",
      description:
        "Developed and deployed a scalable e-learning platform with 10,000+ monthly active users and 1,000+ concurrent live sessions. Integrated real-time chat, video streaming, and live class scheduling features.",
      tech:
        "Angular 12+, AWS (Lambda, CloudFront, S3), WebSockets, PostgreSQL, Node.js",
      achievements:
        "Enabled subscription-based payments using Stripe API and implemented user analytics dashboards for instructors. Achieved 99.9% system uptime and improved session load time by 35% through frontend optimization."
    },
    {
      title: "Jharkhand Police – Fleet Management Portal",
      description:
        "Designed and deployed a state-wide fleet and asset management system used by 100+ police officers across 12 districts. Integrated real-time vehicle tracking with GIS-based visualizations for route optimization and dispatch planning.",
      tech:
        "AngularJS, Python, Odoo ERP, PostgreSQL, REST APIs, GIS Mapping",
      achievements:
        "Reduced manual reporting time by 70% by digitizing legacy processes and automating MIS report generation. The system is fully integrated with GIS for better decision-making and efficient resource management."
    }
  ];
  
  export default projects;